import CookieConsent from "react-cookie-consent";

import {Branding} from '../services/misc';

const CookieConsentX = () => {
    var brandingColor = Branding().ButtonColor

    return (
        <CookieConsent
            location="bottom" 
            buttonText="Jag förstår :)"
            cookieName="CookieConcent_LockIT_"
            style={{ background: "#2B373B", opacity: 0.9 }}
            buttonStyle={{ background:brandingColor, color: "#fff", fontSize: "16px", fontWeight_: "bold" }}
            //declineButtonText="Mer info"
            //enableDeclineButton="true"            
            //declineButtonStyle={{ background:"#46A969", color: "#fff", fontSize: "16px" }}
            expires={10}

            onAccept={(acceptedByScrolling) => {
                // if (acceptedByScrolling) {
                //     // triggered if user scrolls past threshold
                //     alert("Accept was triggered by user scrolling");
                // } else {
                //     alert("Accept was triggered by clicking the Accept button");
                // }
            }}
        >
                Vi använder cookies för att ge dig bästa möjliga kundupplevelse. Om du fortsätter innebär det att du accepterar att cookies används.
        När du besöker våra webbplatser och appar samlar vi in uppgifter från dig för att förbättra din användarupplevelse.

        </CookieConsent>
    );
};

export default CookieConsentX;